import { render, staticRenderFns } from "./MemberAssets.vue?vue&type=template&id=1229962c&scoped=true&"
import script from "./MemberAssets.vue?vue&type=script&lang=js&"
export * from "./MemberAssets.vue?vue&type=script&lang=js&"
import style0 from "./MemberAssets.vue?vue&type=style&index=0&id=1229962c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1229962c",
  null
  
)

export default component.exports